import {Component, Input, Output, EventEmitter, AfterViewInit, OnInit} from "@angular/core";

declare let $: any;

@Component({
  selector: 'widget-radio',
  template: `<div
                [formGroup]="form"
                [class.has-error]="form.controls[id].touched && !form.controls[id].valid"
                [class.has-feedback]="form.controls[id].touched && !form.controls[id].valid">
                <label class="control-label {{labelClass}}" for="{{id}}" [class.active]="model">{{ txtLabel | translate }}</label>
                <div class="{{containerInputClass}}">
                  
                  <div *ngIf="!arraySimples">
                    
                    <div class="radio" *ngFor="let item of listagem">
                      <label>
                        <input type="radio" class="radio-form-{{id}}" name="{{id}}" formControlName="{{id}}"
                               [checked]="model == item[listagemValue]"
                               [value]="item[listagemValue]"
                               (change)="update(item[listagemValue])">
                        {{item[listagemTxt]}}
                      </label>
                    </div>
                    
                  </div>
                  <div class="form-control-feedback" *ngIf="form.controls[id].touched && !form.controls[id].valid">
                    <i class="icon-cancel-circle2"></i>
                  </div>
                  <ng-template [ngIf]="form.controls[id].errors">
                    <span class="help-block" *ngIf="form.controls[id].touched && !form.controls[id].valid && !form.controls[id].errors[id]">{{txt_default_erro}}</span>
                    <div *ngIf="!form.controls[id].valid">
                      <span class="help-block" *ngFor="let erro of form.controls[id].errors[id] | keysBack">{{ 'back.'+erro.key | translate:erro.replace }}</span>
                    </div>
                  </ng-template>
                </div>
              </div>`,
})

export class WidgetRadioComponent implements OnInit, AfterViewInit{

  @Input()
  id: string = '';

  @Input()
  model: any = '';

  @Output() modelChange = new EventEmitter<string>();

  @Input()
  form: any;

  @Input()
  listagem: any;

  @Input()
  listagemValue: any;

  @Input()
  listagemTxt: any;

  @Input()
  listagemTxtSelecione: boolean = true;

  @Input()
  listagemValueSelecione: any = '';

  @Input()
  txt_default_erro: any;

  @Input()
  txtLabel: string = '';

  @Input()
  labelClass: string = 'col-sm-2';

  @Input()
  containerInputClass: string = 'col-sm-10';

  @Input()
  readonly: boolean = false;

  @Input()
  arraySimples: boolean = false;

  constructor(){}

  ngOnInit(): void {
    if(!/text-left/g.test(this.labelClass) && !/text-center/g.test(this.labelClass)){
      this.labelClass = this.labelClass+' text-right';
    }
  }

  ngAfterViewInit(): void {

    let self = this;

    setTimeout(function(){
      $(".radio-form-"+self.id).uniform({
        radioClass: 'choice',
        wrapperClass: 'border-grey-lighter text-grey-lighter'
      });
    }, 1000);

  }

  update(val) {
    console.log('atualizado', val);
    $(".radio-form-"+this.id).uniform.update();
    this.model = val;
    this.modelChange.emit(this.model);
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/form/widget-radio.component.ts